var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MemberProfileSettings.jinja');
require('./MemberProfileSettings.less');

var MemberProfileSettingsInner = require('front/components/MemberProfile/MemberProfileSettingsInner');

var Inner = require('front/components/MemberProfile/MemberProfileSettingsInner');
var Runtime = require('front/components/MemberProfile/MemberProfileSettingsRuntime.jinja');

module.exports = Base.extend({

    template: template,

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'updateBlock');

        window.app.vent.on('MemberProfile--updateSettings', this.updateBlock);

        this.Inner = new Inner({
            el: this.$('.MemberProfileSettingsInner')[0]
        });

        Base.prototype.initialize.call(this, options);
    },


    deactivate: function (params) {
        window.app.vent.off('MemberProfile--updateSettings', this.updateBlock);

        this.Inner.deactivate();
        delete this.Inner;

        return Base.prototype.deactivate.call(this, params);
    },


    updateBlock: function (memberId) {
        this.Inner.deactivate();
        delete this.Inner;

        var data = window.app.data.members[memberId];

        var $template = $(Runtime.render({
            data: window.app.data.members[memberId],
            isOwner: window.app.settings.member == memberId
        }));

        this.$('.MemberProfileSettings-wrapper').html($template);

        this.Inner = new Inner({
            el: this.$('.MemberProfileSettingsInner')[0]
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfile/MemberProfileSettings.js
// module id = 199
// module chunks = 0